import { Component, OnInit, Inject, ViewEncapsulation, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { TrainingVideosService } from '../../training-videos.service';
import { appVer } from '../../app-ver';
import { VideoTraining } from '../../VideoTraining';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./info-dialog.component.scss']
})

export class InfoDialogComponent implements OnInit, OnDestroy {

  appVersion = appVer;
  videoLoading: { id: number, loading: boolean } = {
    loading: false,
    id: null
  };
  currentPlayingIndex: number = null;
  waitVideoInProgress: boolean;

  constructor(
    public dialogRef: MatDialogRef<InfoDialogComponent>,
    public API: TrainingVideosService,
    @Inject(MAT_DIALOG_DATA) public videos: VideoTraining[]
  ) { }

  ngOnInit(): void {
    document.addEventListener('fullscreenchange', this.pauseVideo.bind(this));
  }

  ngOnDestroy(): void {
    document.removeEventListener('fullscreenchange', this.pauseVideo.bind(this));
  }

  closeDialog(): void {
    this.dialogRef.close({ result: 'cancelled' });
  }

  watchVideo(): void {
    const { id } = this.videos[this.currentPlayingIndex];
    this.videoLoading = {
      loading: true,
      id
    };
    this.API.watchTrainingVideo(id).subscribe(() => {
      this.videos[this.currentPlayingIndex].isWatched = true;
    },
    err => {
      console.error(err);
    }, () => {
      this.videoLoading = {
        loading: false,
        id: null
      };
    });
  }

  pauseVideo({ target }: any): void {
    if (target && target.pause && !document.fullscreenElement) {
      target.pause();
      target.style.cursor = 'pointer';
      target.style.objectFit = 'cover';
      target.style.borderRadius = '20px';

      let totalPlayed = 0;
      const played = target.played;

      for (let i = 0; i < played.length; i ++) {
        totalPlayed += played.end(i) - played.start(i);
      }

      const percentage = totalPlayed / target.duration * 100;

      // if video is not watched then we should call the api if the percentage is over 80%
      if (percentage >= 80 && !this.videos[this.currentPlayingIndex].isWatched) {
        this.watchVideo();
      }
    }
  }

  requestFullScreen({ target }: any, index: number): void {
    if (target.readyState === 4) { // 4 means it's loaded
      target.style.objectFit = 'fill';
      target.style.borderRadius = 0;
      target.play();
      target.style.cursor = 'auto'; // when video is in full screen mode, cursor should be auto
      this.currentPlayingIndex = index;

      if (target.requestFullscreen) {
        target.requestFullscreen();
      } else if (target.mozRequestFullScreen) {
        target.mozRequestFullScreen();
      } else if (target.webkitRequestFullscreen) {
        target.webkitRequestFullscreen();
      }
    } else {
      this.loadVideo(target, index);
    }
  }

  loadVideo(target: any, index: number): void {
    target.load(); // load video
    this.waitVideoInProgress = true; // make other videos wait
    this.videos[index].loading = true; // make loading cursor until it loads
  }

  onVideoLoad({ target }: any, index: number): void {
    this.videos[index].loading = false; // this will set loading status to false in each video case
    this.waitVideoInProgress = false;
    this.requestFullScreen({ target }, index);
  }

  onContextMenuOpen(e: Event): void {
    e.preventDefault();
  }

}
